import React from "react";
import withMotion from "../../../../Utils/withMotion";
import Sidebar from "../../Sidebar/Sidebar";
import "../../Blog.scss";
import { Link } from "react-router-dom";

//Utils
import { mapBlogs } from "../../Pagination/utils";

//Images
import img001 from "../../images/sealer/blog-sealer-001.jpg";
import img002 from "../../images/sealer/blog-sealer-002.jpg";
import img003 from "../../images/sealer/blog-sealer-003.jpg";
import img004 from "../../images/sealer/blog-sealer-004.jpg";
import img005 from "../../images/sealer/blog-sealer-005.jpg";
import img006 from "../../images/sealer/blog-sealer-006.jpg";

// SEO
import SEO from "../../../../SEO/index.js";
import StructuredData from "../../../../SEO/structuredData";
import { ViewPavers } from "../../../../CTA/CTA";

export const SealerData = {
  title: "Sealing Concrete Pavers: The How and Why and What to Consider",
  image: img001,
  destination: "/blog/sealing-concrete-pavers-consider",
  date: "September 20, 2016",
  categories: [
    "blog",
    "contractors",
    "driveways",
    "patios",
    "paving-stones",
    "walkways",
  ],
};

const Sealer = () => {
  let blog = [SealerData];

  return (
    <>
      <SEO
        title="How to Seal Concrete Pavers & Why You Should"
        description="Learn why you should and how to seal your concrete pavers as well as when and how often to do it from the experts at Pacific Pavingstone."
        profileURL={
          "https://www.pacificpavingstone.com/blog/sealing-concrete-pavers-consider"
        }
      />
      <StructuredData
        orgaCreator={{
          "@context": "https://schema.org/",
          "@type": "BlogPosting",
          author: {
            "@type": "Organization",
            name: "Pacific Pavingstone",
          },
          URL: "https://www.pacificpavingstone.com/blog/sealing-concrete-pavers-consider",
          headline: "How to Seal Concrete Pavers & Why You Should",
          description:
            "Learn the benefits of outdoor porcelain pavers including the cost, durability, and ease of maintenance. Also, learn how to install! ",
          image: {
            "@type": "ImageObject",
            url: "https://www.pacificpavingstone.com/static/media/blog-sealer-001.255dd869.jpg",
          },
          datePublished: "2016-09-20",
          publisher: {
            "@type": "Organization",
            name: "Pacific Pavingstone",
          },
        }}
      />
      <div className="container-fluid page-blog">
        <div className="row justify-content-center">
          <div className="col-11 col-lg-6">
            {mapBlogs(1, blog, true)}
            <p>
              Great outdoor spaces often incorporate concrete paver patios, pool
              decks, and driveways to enhance the appeal of the property.
              Concrete pavers are durable and low maintenance and come in a
              nearly unlimited variety of sizes and colors. Pavers can last a
              lifetime if taken care of properly, but if neglected, stains or
              fading can reduce the visual beauty of your investment over time.
              <br />
              <br />
              Extending the beauty and lifespan of outdoor hardscapes may
              require applying a sealer to concrete pavers on your property. If
              you are having a paver driveway or patio installed, you ought to
              be asking yourself: “Should I seal my pavers?” Here are a few tips
              on why, when, and how to seal concrete pavers.
            </p>
            <h4>Why Should I Seal My Pavers?</h4>
            <p>
              While pavers are versatile and look great in nearly any outdoor
              environment, it is important to seal them to keep them looking and
              functioning their best for many years to come. Here are a few of
              the benefits that come from sealing your concrete pavers:
            </p>
            <div className="row">
              <div className="col-12 col-md-5">
                <img src={img002} alt="Feature" />
              </div>
              <div className="col-12 col-md-7">
                <p className="text-blue">Protecting the Pavers from Fading</p>
                <p>
                  Paver sealers are valuable for protecting the surface of the
                  pavers from the weathering caused by UV rays. UV degradation
                  causes many materials to break down from extended exposure to
                  the sun. While the concrete pavers themselves are highly
                  durable, the colored pigments in the pavers can slowly fade
                  over time, due to the UV ray exposure. Sealing the pavers
                  helps to keep the paver’s colors vibrant even in bright
                  sunlight.
                </p>
              </div>
            </div>

            <div className="row">
              <div className="col-12 col-md-5">
                <img src={img003} alt="Feature" />
              </div>
              <div className="col-12 col-md-7">
                <p className="text-blue">Enhancing the Colors</p>
                <p>
                  Sealers work much like a varnish other sealers provide for
                  wooden surfaces. Sealers can draw out the colors and contrasts
                  found in the concrete pavers and create greater visual
                  interest. Some sealers have a “Wet Look” that produces an
                  appealing patio surface. Knowledgeable contractors can show
                  you which look would work best for your home, even giving you
                  an on-site demonstration.
                </p>
              </div>
            </div>

            <div className="row">
              <div className="col-12 col-md-5">
                <img src={img004} alt="Feature" />
              </div>
              <div className="col-12 col-md-7">
                <p className="text-blue">
                  Stabilizing Interlocking Joint Sand-
                </p>
                <p>
                  Joint stabilizing sealers have the added benefit of hardening
                  the joint sand in between the pavers, which prevents
                  displacement from wind, rain, and insects that can cause
                  pavers to sink or shift. This is particularly effective for{" "}
                  <Link to="/gallery/pool-decks">pool decks</Link>, to keep sand
                  out of the pool. Joint stabilizing sealers also help reduce
                  weed growth between paver joints.
                </p>
              </div>
            </div>

            <div className="row">
              <div className="col-12 col-md-5">
                <img src={img005} alt="Feature" />
              </div>
              <div className="col-12 col-md-7">
                <p className="text-blue">Stain Removal</p>
                <p>
                  Perhaps the most important benefit of sealers is that they
                  make pavers less porous, which helps limit stains, since the
                  pavers are less able to soak up the oil or dirt, etc. Sealing
                  your concrete pavers makes cleanup of spills easier if they do
                  happen.
                </p>
              </div>
            </div>
            <h4>When Should Pavers Be Sealed?</h4>
            <p>
              Some manufacturers require waiting 1 year after paver installation
              before applying a sealer in order to allow the
              naturally-occurring, white, dusty-looking build up (known as
              efflorescence) to escape from the paving stones.
              <br />
              <br />
              However, we recommend and install B.P. Pro sealers, which are
              breathable and do not require a waiting period, as they let the
              efflorescence escape through the sealer. Environmentally friendly
              B.P. Pro sealers are all also joint stabilizer sealers, and offer
              a great combination of qualities that we believe makes this brand
              the best sealer for concrete pavers in the industry.
            </p>
            <h4>How to Seal Concrete Pavers</h4>
            <p>
              Here are a few of the steps on the actual sealing process and
              appropriate preparations for your pavers before sealing.
              Professional contractors can seal right after construction with
              proper sealers:
            </p>
            <ul>
              <li>
                Make sure the surface is dry, and that rain isn’t in the
                forecast for at least the next 24 hours.
              </li>
              <li>
                Clean the paver surface removing debris and stains. Sweep with a
                good broom, or using a leaf blower, being careful not to blast
                the sand out from between the paver joints.
              </li>
              <li>Pull any weeds growing between pavers.</li>
              <li>
                Apply the sealer with a low-pressure sprayer, covering the
                entire surface of the patio or driveway, etc.
              </li>
              <li>
                Use a squeegee to direct material into the joints and remove
                excess material from the surface.
              </li>
              <li>
                Let the paver surface dry for two or three hours before walking
                on it.
              </li>
              <li>
                Keep off the pavers for 24 hours to allow the sealer to fully
                dry.
              </li>
            </ul>
            <h4>How Often Should Pavers Be Sealed?</h4>
            <p>
              Pavers can be resealed periodically to maintain the high quality
              of the materials for long term. Generally, sealers should be
              reapplied every 3-5 years, but check with your landscape
              contractor to see what they recommend. If your landscape
              contractor sealed the pavers when the patio or driveway was built,
              they will know which sealer to use for subsequent applications.
            </p>

            <div className="row">
              <div className="col-12 col-md-5">
                <img src={img006} alt="Feature" />
              </div>
              <div className="col-12 col-md-7">
                <p>
                  Concrete paver patios, walkways, and driveways are durable and
                  aesthetically pleasing additions to any landscape. If you are
                  dreaming about a concrete paver patio or driveway and looking
                  for a paving contractor in Los Angeles to partner with for the
                  long haul, we’d be happy to talk about sealers and any other
                  paver-related questions you may have.
                  <br />
                  <br />
                  <Link to="/contact-us">
                    Our professional designers at Pacific Pavingstone can help
                    guide you throughout your concrete paver project and give
                    you on site demonstrations of the best sealers for your
                    project, please contact us for a free estimate.
                  </Link>
                </p>
                <ViewPavers/>
              </div>
            </div>
          </div>
          <Sidebar />
        </div>
      </div>
    </>
  );
};

export default withMotion(Sealer);
